// Thirdparty
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

// Theme
import '@styles/index.css'

import components from '@scripts/components'
import mailingList from '@scripts/components/mailing-list'
import mobileBar from '@scripts/components/mobile-bar'
import pageOverlay from '@scripts/components/page-overlay'
import scrollReveal from '@scripts/components/scroll-reveal'
import scrollTo from '@scripts/components/scroll-to'
import siteAnnouncementBar from '@scripts/components/site-announcement-bar'
import siteHeader from '@scripts/components/site-header'
import siteWidget from '@scripts/components/site-widget'
import slideToggle from '@scripts/components/slide-toggle'

window._scrollTimelines = []

components.init()
mailingList.init()
mobileBar.init()
pageOverlay.init()
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  scrollReveal.init()
}
scrollTo.init()
siteAnnouncementBar.init()
siteHeader.init()
siteWidget.init()
slideToggle.init()

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('_preload')
  }, 250)
})
